import { createDefaultTyrann, objectError } from '@apis/common';
import { company, companyCreateStaff, companyDetails, patchCompanyBody } from '@models/Company';
import { companyStaff } from '@models/User';
import * as t from 'io-ts';
import * as h from 'tyrann-io';

export const companyApis = createDefaultTyrann({
  '/company/': {
    get: {
      response: {
        200: companyDetails,
      },
    },
    patch: {
      body: patchCompanyBody,
      response: {
        200: company,
        400: t.type({
          non_field_errors: h.omittable(t.array(t.string)),
        }),
      },
    },
  },
  '/company/application/': {
    post: {
      response: {
        200: t.type({
          message: t.string,
        }),
        400: objectError,
      },
    },
  },
  '/company/staff/': {
    get: {
      query: t.type({
        page: t.number,
      }),
      response: {
        200: t.type({
          count: t.number,
          results: t.array(companyStaff),
        }),
      },
    },
    post: {
      body: companyCreateStaff,
      response: {
        200: t.type({
          message: t.string,
        }),
        400: t.partial({
          email: t.array(t.string),
        }),
        409: t.type({
          message: t.string,
        }),
      },
    },
  },
  '/company/{id}/staff/': {
    get: {
      path: t.type({
        id: t.number,
      }),
      query: t.type({
        company: t.number,
        page: t.number,
      }),
      response: {
        200: t.type({
          message: t.string,
        }),
        409: t.type({
          message: t.string,
        }),
      },
    },
  },
  '/company/staff/{id}/': {
    delete: {
      path: t.type({
        id: t.number,
      }),
      response: {
        200: t.type({
          message: t.string,
        }),
      },
    },
  },
  '/company/refresh_grade/': {
    post: {
      response: {
        200: t.type({}),
      },
    },
  },
});
